import React from "react";
import { useIntl } from "react-intl";
import styles from "./TitleFormTabs.module.css";
/**
 * Horizontal pill-style tab bar for the title form.
 *
 * Renders one rounded button per tab. The active tab is filled with the
 * primary colour, inactive tabs are outlined. Tabs with validation errors
 * show a small red badge with the error count.
 */
var TitleFormTabs = function (_a) {
    var tabs = _a.tabs, activeTab = _a.activeTab, onTabChange = _a.onTabChange;
    var formatMessage = useIntl().formatMessage;
    return (React.createElement("div", { className: styles.tabs, role: "tablist" }, tabs.map(function (tab) {
        var isActive = tab.id === activeTab;
        return (React.createElement("button", { key: tab.id, type: "button", role: "tab", "aria-selected": isActive, className: "".concat(styles.tab, " ").concat(isActive ? styles.active : ""), onClick: function () { return onTabChange(tab.id); } },
            formatMessage({ id: tab.labelId }),
            tab.errorCount > 0 && (React.createElement("span", { className: styles.badge, "aria-label": formatMessage({ id: "ui-br-agency.title.form.tab.errorCount" }, { count: tab.errorCount }) }, tab.errorCount))));
    })));
};
export default TitleFormTabs;
